// extracted by mini-css-extract-plugin
export var threeUpGrid = "standardMultipurposePage-module--three-up-grid--2shmY";
export var card = "standardMultipurposePage-module--card--Ag0h9";
export var heading = "standardMultipurposePage-module--heading--2KyIY";
export var heroMedia = "standardMultipurposePage-module--hero-media--3uCJK";
export var form = "standardMultipurposePage-module--form--J9ZYr";
export var sectionHeaderWrap = "standardMultipurposePage-module--section-header-wrap--1gg4C";
export var sectionHeader = "standardMultipurposePage-module--section-header--2tUvs";
export var headingLeft = "standardMultipurposePage-module--heading-left--1Lniu";
export var testimonialGrid = "standardMultipurposePage-module--testimonial-grid--3dxZL";
export var testimonial = "standardMultipurposePage-module--testimonial--3_ICj";
export var logos = "standardMultipurposePage-module--logos--lQe7U";
export var logoCta = "standardMultipurposePage-module--logo-cta--2SoKv";
export var logoGrid = "standardMultipurposePage-module--logo-grid--37PAy";
export var logo = "standardMultipurposePage-module--logo--2g9JM";
export var grey = "standardMultipurposePage-module--grey--2ZH2W";
export var blue = "standardMultipurposePage-module--blue--1Vvi6";
export var purple = "standardMultipurposePage-module--purple--3uuU5";
export var purplePinkGradient = "standardMultipurposePage-module--purple-pink-gradient--3UWz4";
export var lightGrey = "standardMultipurposePage-module--light-grey--2Me0Q";
export var white = "standardMultipurposePage-module--white--1Y0bB";
export var purplePink = "standardMultipurposePage-module--purple-pink--2Es2y";
export var darkBlue = "standardMultipurposePage-module--dark-blue--2qrHj";
export var stacked = "standardMultipurposePage-module--stacked--2c_Mc";
export var copy = "standardMultipurposePage-module--copy--5ozP1";
export var formCopy = "standardMultipurposePage-module--form-copy--2nsDm";
export var competitivePage = "standardMultipurposePage-module--competitive-page--RByKi";